/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import { DatastoreEventAdapter } from 'PlugAndPlay/_data-layer/js/Adapters/EventAdapters/DatastoreEventAdapter/DatastoreEventAdapter';
import { CalendarViews, EventActions } from './enums';

// Lazy load the main Calendar 'app'
const Calendar = React.lazy(() =>
    import(/* webpackChunkName: "Calendar" */ './calendar')
);

const appWrapper = document.querySelectorAll('[data-component="calendar"]');
// Don't run on a non calendar page
if (appWrapper.length > 0) {
    // Only load ReactDOM from if its needed as its pretty large
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom').then((ReactDOM) => {
        appWrapper.forEach((wrapper) => {
            const eventAdapters = [];
            const { dataset } = wrapper;
            const calendarConfiguration = JSON.parse(
                dataset.calendarConfiguration
            );

            // Grab all the configured data sources
            if (calendarConfiguration.datasource === 'datastore') {
                const datastore = new Datastore({
                    serviceURL: calendarConfiguration.datasourceUrl,
                    jwtURL: calendarConfiguration.datasourceJWT,
                });

                eventAdapters.push(
                    new DatastoreEventAdapter({
                        datastore,
                        sourceId: 'datastore',
                    })
                );
            }

            if (calendarConfiguration.datasource2 === 'datastore') {
                const datastore2 = new Datastore({
                    serviceURL: calendarConfiguration.datasourceUrl2,
                    jwtURL: calendarConfiguration.datasourceJWT2,
                });

                eventAdapters.push(
                    new DatastoreEventAdapter({
                        datastore: datastore2,
                        sourceId: 'datastore2',
                    })
                );
            }

            let defaultView = CalendarViews.Day;
            if (calendarConfiguration.defaultView === 'Schedule') {
                defaultView = CalendarViews.Schedule;
            }

            let eventAction = EventActions.OpenInModal;
            if (calendarConfiguration.eventAction === 'link') {
                eventAction = EventActions.OpenAsLink;
            } else if (calendarConfiguration.eventAction === 'page') {
                eventAction = EventActions.OpenInNewPage;
            }

            ReactDOM.render(
                <Suspense
                    fallback={
                        <div className="calendar__loading">Loading...</div>
                    }
                >
                    <Calendar
                        {...calendarConfiguration}
                        defaultView={defaultView}
                        eventAdapters={eventAdapters}
                        eventAction={eventAction}
                    />
                </Suspense>,
                wrapper
            );
        });
    });
}
